import { h } from 'vue'
import { useGlobals } from '@/main.js'
import DateHeader from '../../HeaderCells/DateHeader.vue'
import enums from '@/plugins/enums'

export const registerAppointmentColumn = (dashboard, { dateColor }) => {
  const { $format } = useGlobals()

  dashboard.registerCustomColumn({
    name: 'latest_appointment',
    label: 'monolith.shared.appointment',
    component: (props) => {
      const appointment = props.row.latest_appointment

      if (!appointment || appointment.status === enums.appointmentStatus.CANCELLED_BY_VALUER) {
        return null
      }

      const shouldColor = props.row.status === 'submitted'
      const colorClass = shouldColor ? dateColor(appointment) : ''
      const formattedAppointment = $format.appointment(appointment)

      return h('span', { class: colorClass }, formattedAppointment)
    },
    options: {
      headerComponent: DateHeader,
    },
  })
}
